import { useQuery } from '@tanstack/react-query';
import Api from '@/services/api';

type Organization = {
	id: string;
	name: string;
};

async function getOrganizations(): Promise<Organization[]> {
	const { data } = await Api.get('/organization/user_list');
	return data;
}

export const useGetOrganizations = () => {
	return useQuery<Organization[]>(['organizations'], () => getOrganizations());
};
